import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlockListSpot } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { BlockListSpotsComponent } from '@features/spots/umbraco-block-list-spot/block-list-spots.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-umbraco-block-list',
    template: ` <app-block-list-spots *ngIf="spots" [spots]="spots" [theme]="theme"></app-block-list-spots> `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, BlockListSpotsComponent]
})
export class UmbracoBlockListComponent {
    @Input()
    spots?: BlockListSpot[];

    @Input()
    theme?: string;
}
